import styled from 'styled-components'

interface IProps {
  width: number
  children: JSX.Element | JSX.Element[]
  className?: string
}

const MainContentLayout = ({ children, width, className }: IProps) => {
  return (
    <Section className={className} width={width}>
      {children}
    </Section>
  )
}

const Section = styled.section<{ width: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: 2.25rem 1.5rem;
  background: ${({ theme }) => theme.colors.grey.lightest};
  box-shadow: 0 0.25rem 0.25rem 0 ${({ theme }) => `${theme.colors.grey.darker}40`};
  border-radius: ${({ theme }) => theme.borderRadius.rounded};
  border: 1.5px solid ${({ theme }) => theme.colors.grey.light};
  width: ${({ theme, width }) => theme.util.pixelToRem(width)};
`

export { MainContentLayout }
